import type { PricingCardProps } from './PricingCard';

const PRO_DISCOUNT_PERCENT = 40;
const DEFAULT_DISCOUNT_PERCENT = 20;

export const getAnnualDiscountPercent = ({
  planType,
}: {
  planType: PricingCardProps['type'];
}): number =>
  planType === 'Pro' || planType === 'Business'
    ? PRO_DISCOUNT_PERCENT
    : DEFAULT_DISCOUNT_PERCENT;

export const getMaxAnnualDiscountPercent = (): number => PRO_DISCOUNT_PERCENT;
